import { get } from "lodash";
import { MDBContainer, MDBSideNav } from "mdbreact";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Button from "~/components/common/atoms/Button";
import { partnerInfo } from "~/configs/partnerDetails";
import { VERSION_DATE, VERSION_WEB } from "~/configs/version";
import history from "~/history";
import { redirectToMedproId } from "~/store/login/actions";
import { logOut } from "~/store/user/userAction";

import logo_medpro from "~/assets/img/desktop/icon/logo.svg";
import logo_nhidonghcm from "~/assets/img/desktop/logo/nhidonghcm/logo_header_nhidonghcm.gif";

import cx from "classnames";
import { urlLogoHeader } from "~/utils/manageResource";
import partnerId from "~/utils/partner";
import styles from "./style.module.scss";

const Drawer = ({
  isDrawer,
  handleToggle,
  IsAuthenticated,
  info,
  logOut,
  redirectToMedproId
}) => {
  const menu = get(partnerInfo, "menu");
  const fullName = get(info, "fullName", "");
  const userName = get(info, "userName", "");
  const displayName = fullName !== "" ? fullName : userName;

  const handleLogout = () => {
    logOut();
    history.push("/");
  };

  menu.map((item, index) => {
    return (
      <li
        className={index === 0 ? styles.first_row : ""}
        key={index}
        onClick={handleToggle}
      >
        <Link to={item.link}>
          <i className={item.icon} />
          {item.name}
        </Link>
      </li>
    );
  });

  return (
    <div className={cx(styles.menu_mobile, styles["menu_mobile_" + partnerId])}>
      <MDBContainer>
        <MDBSideNav
          href="/"
          hidden
          right
          triggerOpening={isDrawer}
          breakWidth={1300}
          showOverlay={false}
          className={styles.bg_menu_mobile}
          onClick={handleToggle}
        >
          <div className={styles.header_drawer}>
            <div
              className={partnerId === "medpro" ? null : styles.header_brand}
            >
              <a
                href="https://medpro.vn"
                target="_blank"
                rel="noreferrer"
                className={styles.logoFooter}
              >
                <img
                  src={logo_medpro}
                  alt="Logo Medpro"
                  className={styles.logoImg}
                />
              </a>
              <Link to="/">
                <img
                  src={
                    partnerId === "nhidonghcm" ? logo_nhidonghcm : urlLogoHeader
                  }
                  alt="Umc"
                  className={styles.logoPartner}
                />
              </Link>
            </div>

            <li onClick={handleToggle}>
              <i className={cx(styles.iconClose, "fal fa-times")} />
            </li>
          </div>

          {/* <li className={styles.li_download}>
            <div className={styles.download}>
              <p className={styles.txtDown}>Tải ứng dụng</p>

              <ul className={styles.list_group}>
                <li>
                  <LazyLoad height={45} className={styles.image}>
                    <a href={LINK_IOS_APP} {...tagA}>
                      <img src={ios} alt="" />
                    </a>
                  </LazyLoad>
                </li>
                <li>
                  <LazyLoad height={45} className={styles.image}>
                    <a href={LINK_ANDROID_APP} {...tagA}>
                      <img src={android} alt="" />{" "}
                    </a>
                  </LazyLoad>
                </li>
              </ul>
            </div>
              </li> */}
          {IsAuthenticated ? (
            <li className={styles.li_sau_dn}>
              <img
                style={{ width: "18px", marginRight: "15px" }}
                src={require("~/assets/img/desktop/logo/medpro_circle.svg")}
                alt="zalo"
              />
              Xin chào&nbsp;<strong>{displayName}</strong>
            </li>
          ) : (
            <li className={styles.li_dangnhap}>
              <Button
                create="create"
                block="block"
                onClick={() => {
                  redirectToMedproId();
                }}
              >
                Đăng nhập tài khoản
              </Button>
            </li>
          )}
          {IsAuthenticated && (
            <React.Fragment>
              <li>
                <Link
                  to={{
                    pathname: "/user",
                    state: { activeItem: 1 }
                  }}
                >
                  <i className="fal fa-user" />
                  Hồ sơ bệnh nhân
                </Link>
              </li>

              <li className={styles.first_row}>
                <Link
                  to={{
                    pathname: "/user",
                    state: { activeItem: 2 }
                  }}
                >
                  <i className="fal fa-file-invoice" />
                  Phiếu khám bệnh
                </Link>
              </li>
            </React.Fragment>
          )}
          <li>
            <Link to="/">
              <i className="far fa-home" />
              Trang chủ
            </Link>
          </li>
          <li>
            <Link to="/gioi-thieu">
              <i className="fal fa-info-circle" />
              Giới thiệu
            </Link>
          </li>
          <li>
            <Link to="/quy-trinh">
              <i className="far fa-cog" />
              Quy trình
            </Link>
          </li>
          <li>
            <Link to={partnerId === "medpro" ? "/huong-dan" : "/"}>
              <i className="fal fa-book-open" />
              Hướng dẫn
            </Link>
          </li>
          <li>
            <Link to="/thac-mac">
              <i className="fal fa-question-circle" />
              Thắc mắc
            </Link>
          </li>
          <li className={partnerId === "medpro" ? null : styles.first_row}>
            <Link to="/lien-he">
              <i className="far fa-address-card" />
              Liên hệ
            </Link>
          </li>
          {partnerId === "medpro" ? (
            <li className={styles.first_row}>
              <Link to="/clinic">
                <i className="fas fa-desktop" />
                Quản lý phòng mạch/phòng khám
              </Link>
            </li>
          ) : null}
          <li>
            <a
              href="https://zalo.me/4018184502979486994"
              target="_blank"
              className={styles.zalo}
              rel="noopener noreferrer"
            >
              <img
                src={require("~/assets/img/desktop/icon/zalo.svg")}
                alt="Hỗ trợ Zalo"
              />
              Hỗ trợ Zalo
            </a>
          </li>
          <li>
            <a
              href="https://m.me/www.medpro.vn"
              target="_blank"
              rel="noopener noreferrer"
              title="19002115"
              className={styles.zalo}
            >
              <img
                src={require("~/assets/img/desktop/icon/facebook.svg")}
                alt="Hỗ trợ Facebook"
              />
              Hỗ trợ Facebook
            </a>
          </li>
          <li>
            <a href="tel:19002115" title="19002115">
              <i className="far fa-life-ring" />
              Hỗ trợ đặt khám: 1900-2115
            </a>
          </li>
          <li className={styles.first_row}>
            <a href="mailto:support@medpro.com.vn">
              <i className="fal fa-envelope" />
              Email: support@medpro.com.vn
            </a>
          </li>
          {IsAuthenticated && (
            <li>
              <Link
                onClick={() => {
                  handleLogout();
                }}
                to="#"
              >
                <i className="fal fa-sign-out-alt" />
                Đăng xuất
              </Link>
            </li>
          )}
          <li>
            <i className={styles.version}>
              Phiên bản: {VERSION_WEB} &emsp; &emsp; Mới nhất: {VERSION_DATE}
            </i>
          </li>
        </MDBSideNav>
      </MDBContainer>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated, info }
  } = state;
  return {
    IsAuthenticated,
    info
  };
};

export default connect(mapStateToProps, {
  logOut,
  redirectToMedproId
})(Drawer);
